import { connect } from "react-redux"
import { getOfferStartDateString } from "utilities/time"
import { offerRequestSelected } from "modules/Seller/OfferRequests/actions"
import { offerSelected } from "modules/Seller/Offers/actions"
import routeNames from "components/navigators/constants"
import _ from "lodash"
import View from "./view"
import { Navigation } from "components/types"
import { Store } from "utilities/Redux/store"
import { getSellerOfferById } from "modules/Seller/Offers/selectors"
import { getBuyerProfileForId } from "modules/BuyerProfiles/selectors"
import { getCategoryById } from "modules/Buyer/Categories/selectors"
import { getOfferRequestByIdForSeller } from "modules/Seller/OfferRequests/selectors"
import { getLocaLizedName } from "utilities/Redux/normalizeHelpers"

interface OwnProps {
  id: string
  navigation: Navigation
}

const mapStateToProps = (state: Store, ownProps: OwnProps) => {
  const offer = getSellerOfferById(state, ownProps.id)
  const offerRequest =
    offer && getOfferRequestByIdForSeller(state, offer.offerRequest)
  const category = offerRequest && getCategoryById(state, offerRequest.category)
  const buyerProfile =
    offerRequest && getBuyerProfileForId(state, offerRequest.buyerProfile)
  return {
    offerRequest,
    category,
    offer,
    buyerProfile,
  }
}

const mapDispatchToProps = {
  offerRequestSelected,
  offerSelected,
}

let lock: boolean
const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
  ownProps: OwnProps,
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onPress: () => {
    if (lock) {
      return
    }
    lock = true
    if (stateProps.offerRequest && stateProps.category && stateProps.offer) {
      dispatchProps.offerRequestSelected(stateProps.offerRequest.id)
      dispatchProps.offerSelected(ownProps.id)

      ownProps.navigation.navigate(
        routeNames.SELLER.OPEN_OFFER_REQUEST_DETAILS,
        {
          name: `${getLocaLizedName(
            stateProps.category.name,
          )} ${getOfferStartDateString(stateProps.offer)}`,
        },
      )
    }

    setTimeout(() => {
      lock = false
    }, 500)
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(View)
